<template >	
	<v-dialog slot="activator" v-model="dialog" persistent max-width="500">
        <v-btn small slot="activator" icon style="margin: 0px; margin-left:10px;">
        	<v-icon color="grey darken-2" small>supervisor_account</v-icon>
        </v-btn>
        <v-card >

        	<v-toolbar><v-toolbar-title>
        		{{deptPCT.userDeptID ? 'CHANGE USER DEPT' : 'ADD USER DEPARTMENT'}}
        	</v-toolbar-title></v-toolbar>

        	<v-card-title class="body-2" color="black">
         		<v-layout column class="pl-1 pt-2">
	         		<v-flex>
	         			<v-layout row>
	         				<v-flex xs4>Room:</v-flex>
	         				<v-flex v-if="room">{{room.bldgAlpha}} - {{room.number}}</v-flex>
         				</v-layout>
         				<v-layout row>
	         				<v-flex xs4>Assigned Dept:</v-flex>
	         				<v-flex>{{deptPCT.deptID}} - {{deptPCT.deptName}}</v-flex>
         				</v-layout>
         				<v-layout v-if="deptPCT.userDeptID" row>
	         				<v-flex xs4>Current User Dept:</v-flex>
	         				<v-flex>{{deptPCT.userDeptID}} - {{deptPCT.userDeptName}}</v-flex>
         				</v-layout>
         			</v-flex>
         		</v-layout>
         	</v-card-title> 

        	<v-card-text class="pb-5">
        		<v-layout >
        			<v-flex>
						<v-autocomplete
							:items="depts"
							item-text="deptNameAndID"
							item-value="deptID"
							v-model="select"
							cache-items
							class=""
							flat
							light
							hide-no-data
							hide-details
							label="Select User Department"
							solo-inverted
							autofocus
						></v-autocomplete>
					</v-flex>
		  		</v-layout>		        
			</v-card-text>

        	<v-card-actions>
	          	<v-spacer></v-spacer>
	          	<v-btn color="green darken-1" flat @click.native="dialog=false">Cancel</v-btn>
	          	<v-btn color="green darken-1" flat @click.native="setUserDept">
	          		{{deptPCT.userDeptID ? 'CHANGE' : 'ADD' }}
	          	</v-btn>
	          	<v-tooltip top>
	          		<template v-slot:activator="{ on }">
	          			<v-btn v-on="on" v-if="deptPCT.userDeptID" color="green darken-1" flat @click.native="clearUserDept">Clear</v-btn>
	          		</template>
	          		<span>Will Clear User Dept</span>
	          	</v-tooltip>
	        </v-card-actions>

    	</v-card>
    </v-dialog>
    
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'
import { AUTH_COOKIE } from '@/store/modules/user'
import { AUTH_API_COOKIE } from '@/store/modules/user'
import jscookie from 'js-cookie'
import Vue from 'vue'

export default {
	props: [ 'add', 'icon', 'small', 'deptPCT', 'deptID', 'room' ],

	data () {
			return {
			checkbox: false,
			loading: false,
			items: [],
			search: null,
			select: this.deptPCT ? this.deptPCT.userDeptID : null,
			dialog: false,
		}
	},

	computed: {
			...mapState({ 	depts: 	state => state.lists.depts			}),
	},

	methods: {
		...mapMutations(['setSnackText',  ]),
		...mapActions([ 'updateRoomPercentage', 'insertRoomPercentage', 'fetchFullRoom', 'updateUserDept']),
		
		setUserDept () {
			if (!this.select) { return }
			const payload = { pctKey: this.deptPCT.key, userDeptID: this.select}
			this.updateUserDept(payload).then((response) => { 
				this.refresh(response)	
			})				
		},		

		clearUserDept () {
			const payload = { pctKey: this.deptPCT.key, userDeptID: null}
			this.updateUserDept(payload).then((response) => { 
				this.refresh(response)	
			})
		},

		refresh(response) {
			if (response == "Saved") {
					this.$emit('success', true)
					// reset and refresh things
					this.$emit('updateLoading', true)
					this.$emit('refresh')
					this.dialog = false
					this.select = null
			} else {
				this.setSnackText(response)
			}
		},

	}
}

</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/forms/AddUserDepartment.vue